import React from "react";
import Text from "shared/ui/typography/Text";
import { USPListItemType } from "shared/utils/usps";
import ColoredCheckmark from "../../../shared/ui/colored-checkmark";

interface USPHeaderListProps {
  uspList: USPListItemType;
}

export const USPHeaderList: React.FC<USPHeaderListProps> = React.memo(
  ({ uspList }) => {
    return (
      <div>
        <ul className="gg-pt-5 gg-grid gg-gap-y-[0.4rem] ">
          {Object.values(uspList).map((usp, index) => (
            <li
              key={index}
              className="gg-flex lg:gg-items-center gg-gap-x-[0.35rem]"
            >
              <ColoredCheckmark fill={"#69B578"} />
              <Text className="gg-text-slate-800 gg-text-sm gg-leading-6 gg-w-full">
                {usp}
              </Text>
            </li>
          ))}
        </ul>
      </div>
    );
  }
);
